<template>
  <div class="deleteMember">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
    >
      <van-checkbox-group v-model="result">
        <van-checkbox
          class="list_item"
          :name="item.UserInfo[0].uid"
          v-for="(item, index) in list"
          :key="index"
          checked-color="#ff410a"
        >
          <div class="item">
            <img :src="item.UserInfo[0].avatar" />
            <span>{{ item.UserInfo[0].nickname }}</span>
          </div>
        </van-checkbox>
      </van-checkbox-group>
    </van-list>
    <div class="btns">
      <div class="btn" @click="cancel">取消</div>
      <div class="delete_btn" @click="deleteMember">删除</div>
    </div>
  </div>
</template>

<script>
import { List, Checkbox, CheckboxGroup, Toast } from "vant";
import { postDelTeamUser } from "@/api/public";
export default {
  name: "MyTeamDeleteMember",
  components: {
    [List.name]: List,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      result: []
    };
  },
  mounted() {
    this.list = JSON.parse(this.$route.query.list);
    this.finished = true;
    this.loading = true;
  },
  methods: {
    /**
     * 取消
     */
    cancel() {
      this.$router.replace({ name: "MyTeam" });
    },
    /**
     * 删除
     */
    deleteMember() {
      if (this.result.length == 0) {
        Toast({ message: "请选择删除的成员" });
        return;
      }
      let i = 0;
      this.result.forEach(item => {
        postDelTeamUser({
          uid: item,
          team_id: this.$route.query.id
        })
          .then(res => {
            i++;
            Toast({ message: "删除成功" });
            this.$router.replace({ path: "/my/team" });
          })
          .catch(err => {
            i++;
            Toast({ message: "删除成功" });
            this.$router.replace({ path: "/my/team" });
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.deleteMember {
  min-height: 100vh;
  padding-bottom: 1.5rem;
  .list {
    margin-top: 0.2rem;
    .list_item {
      background: #ffffff;
      padding: 0.2rem 0.3rem;
      .item {
        display: flex;
        align-items: center;
        font-size: 0;
        img {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 50%;
          margin-right: 0.2rem;
        }
        span {
          font-size: 0.28rem;
        }
      }
    }
  }
  .btns {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    height: 1rem;
    padding: 0.1rem 0.3rem;
    div {
      width: calc((100% - 0.2rem) / 2);
      text-align: center;
      line-height: 0.8rem;
      border: 1px solid #f1f1f1;
      border-radius: 0.1rem;
      &.delete_btn {
        background: #ff410a;
        color: #ffffff;
      }
    }
  }
}
</style>
